module.exports = __webpack_public_path__ + "media/images/icons/map/marker-passenger-aa861ee6e81db6961e19cd3c4f930133.png";